export const electrician = {
  id: "electrician",
  name: "Electrician",

  scene: {
    backgroundImage: null,
    baseColor: "#080c18",
    radialGlow: "radial-gradient(ellipse at 50% 40%, rgba(80, 140, 255, 0.10) 0%, transparent 60%)",
    overlayTint: "rgba(6, 10, 18, 0.36)",
    vignette: 0.62,
    parallaxStrength: 0.38,
    particleType: "electric",
  },

  glass: {
    bg: "rgba(8, 12, 24, 0.58)",
    blur: 16,
    border: "rgba(80, 140, 255, 0.20)",
    radius: 14,
  },

  glow: {
    edgeColor: "rgba(80, 140, 255, 0.50)",
    edgeStrength: 0.50,
    heroBoost: 0.6,
  },

  accent: {
    primary: "#5090ff",
    secondary: "#3060c0",
  },

  numeric: {
    positive: "#22c55e",
    warning: "#f59e0b",
    danger: "#ef4444",
  },

  ai: {
    orbStyle: "bot",
    orbGlow: "rgba(80,140,255,0.35)",
  },

  tokens: {
    "--tl-bg-0": "#080c18",
    "--tl-bg-1": "#060a14",
    "--tl-bg-2": "#03050c",
    "--tl-text-0": "#d8e4f8",
    "--tl-text-1": "#b0c0d8",
    "--tl-text-muted": "#7888a8",
    "--tl-accent-0": "#5090ff",
    "--tl-accent-1": "#3060c0",
    "--tl-glass-bg": "rgba(8, 12, 24, 0.58)",
    "--tl-glass-border": "rgba(80, 140, 255, 0.20)",
    "--tl-glass-blur": "16px",
    "--tl-glass-shadow": "0 10px 30px rgba(0,0,0,0.50)",
    "--tl-glass-glow-color": "rgba(80,140,255,0.3)",
    "--tl-glow-edge-color": "rgba(80, 140, 255, 0.50)",
    "--tl-glow-edge-strength": "0.50",
    "--tl-glow-hero-boost": "0.6",
    "--tl-radius": "14px",
    "--tl-molten-wordmark-gradient": "none",
  },
};
